import React from 'react';

import {
    AlertIcon,
    ApiReferenceIcon,
    AssessmentIcon,
    BlogIcon,
    ChangelogIcon,
    DataFeedsIcon,
    DatasetsIcon,
    DocumentationIcon,
    ExploitsAndKevIcon,
    ExploitsIcon,
    GlossaryIcon,
    McpForAiAgentsIcon,
    McpIcon,
    OssAndToolsIcon,
    SecurityAndAutomationSdkIcon,
    SupportIcon,
    VulnerabilityIntelligenceIcon,
    WhiteLabelIcon
} from 'pages/Landings/components/Icons';
import MenuItem from 'pages/Landings/components/TopMenu/components/MenuItem';
import SubMenu from 'pages/Landings/components/TopMenu/components/SubMenu';
import SubMenuItem from 'pages/Landings/components/TopMenu/components/SubMenuItem';

interface Props {
    container?: () => HTMLElement;
}
export const Default: React.FC<Props> = ({ container }) => {
    return (
        <>
            <MenuItem to="#products" title={'Products'} container={container} anchor={container}>
                <SubMenu>
                    <SubMenuItem
                        icon={<VulnerabilityIntelligenceIcon />}
                        to="/products/vulnerability-intelligence"
                        title="Vulnerability Intelligence"
                        subtitle="Сontext enrichment"
                    />
                    <SubMenuItem
                        icon={<AssessmentIcon />}
                        to="/products/assessment"
                        title="Assessment"
                        subtitle="Instant software assessment"
                    />
                    <SubMenuItem
                        icon={<DatasetsIcon />}
                        to="/products/datasets"
                        title="Datasets"
                        subtitle="Unified datasets"
                    />
                    <SubMenuItem
                        icon={<AlertIcon />}
                        to="/products/alerts"
                        title="Alert"
                        subtitle="Targeted vuln alerts"
                    />
                    <SubMenuItem
                        icon={<ExploitsIcon />}
                        to="/products/exploits"
                        title="Exploits"
                        subtitle="Real-world exploit tracking"
                    />
                    <SubMenuItem
                        icon={<McpIcon />}
                        to="/products/mcp"
                        title="MCP"
                        subtitle="Live AI vulnerability feed"
                    />
                </SubMenu>
            </MenuItem>
            <MenuItem to="#solutions" title={'Solutions'} container={container} anchor={container}>
                <SubMenu>
                    <SubMenuItem icon={<WhiteLabelIcon />} to="/solutions/white-label" title="White label" />
                    <SubMenuItem icon={<DataFeedsIcon />} to="/solutions/data-feeds" title="Data feeds" />
                    <SubMenuItem
                        icon={<McpForAiAgentsIcon />}
                        to="/solutions/mcp-for-ai-agents"
                        title="MCP for AI Agents"
                    />
                    <SubMenuItem
                        icon={<SecurityAndAutomationSdkIcon />}
                        to="/solutions/security-automation-sdk"
                        title="Security Automation SDK"
                    />
                    <SubMenuItem
                        icon={<ExploitsAndKevIcon />}
                        to="/solutions/exploits-and-kev"
                        title="Exploits & KEV"
                    />
                </SubMenu>
            </MenuItem>
            <MenuItem to="/pricing" title={'Pricing'} container={container} anchor={container} />
            <MenuItem to="#resources" title={'Resources'} container={container} anchor={container}>
                <SubMenu>
                    <SubMenuItem icon={<DocumentationIcon />} href="https://docs.vulners.com" title="Documentation" />
                    <SubMenuItem
                        icon={<ApiReferenceIcon />}
                        href="https://docs.vulners.com/docs/api/"
                        title="API reference"
                    />
                    <SubMenuItem icon={<OssAndToolsIcon />} href="https://github.com/vulnerscom" title="OSS & Tools" />
                    <SubMenuItem
                        icon={<ChangelogIcon />}
                        href="https://docs.vulners.com/changelog"
                        title="Change Log"
                    />
                    <SubMenuItem icon={<GlossaryIcon />} href="/glossary" title="Glossary" />
                    <SubMenuItem icon={<BlogIcon />} href="/blog" title="Blog" />
                    <SubMenuItem icon={<SupportIcon />} to="/company/contacts" title="Support" />
                </SubMenu>
            </MenuItem>
            <MenuItem to="/company/contacts" title={'Company'} container={container} anchor={container} />
        </>
    );
};
